//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TopScreen from '~/components/TopScreen.vue'
import FooterTop from '~/components/footer/footerTop.vue'
import DescriptionBlock from '~/components/forCompanies/DescriptionBlock.vue'
import HowItWorks from '~/components/common/HowItWork.vue'

export default {
  components: {
    TopScreen,
    FooterTop,
    DescriptionBlock,
    HowItWorks
  },
  head () {
    return {
      title: this.$t('footer.payment-methods.boleto').concat(' | Pagsmile '),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('seo.description')
        }
      ]
    }
  },
  data () {
    return {
      hiw: {
        title: 'boleto.block3.title',
        steps: [
          'boleto.block3.item1',
          'boleto.block3.item2',
          'boleto.block3.item3',
          'boleto.block3.item4'
        ],
        imgs: [
          require('@/assets/img/payment-methods/boleto/b3-1.png'),
          require('@/assets/img/payment-methods/boleto/b3-2.png'),
          require('@/assets/img/payment-methods/boleto/b3-3.png'),
          require('@/assets/img/payment-methods/boleto/b3-4.png')
        ]
      }
    }
  }
}
